export default __webpack_public_path__ + "static/media/before_me.fde469cd.webp";